<template>
    <div>
        <div class="list-title">
            <div>序号</div>
            <div>作业名称</div>
            <div>班级</div>
            <div>提交人</div>
            <div>发布时间</div>
            <div>提交时间</div>
            <div></div>
        </div>
        <div class="list" v-for="(l,index) in list" :class="l.status===0?'color-orange':''">
            <div>{{index+1}}</div>
            <div>{{l.jobName}}</div>
            <div>{{l.gradeName}}</div>
            <div>{{l.operatorName}}</div>
            <div>{{l.createTime}}</div>
            <div>{{l.completionTime}}</div>
            <div>
                <button class="check-btn" @click="openInfo(l)" v-if="l.status==='0'">催办</button>
                <button class="check-btn" @click="openInfo(l)" v-if="l.status==='1'">审批作业</button>
                <button class="check-btn" @click="openInfo(l)" v-if="l.status==='2'">查看</button>
            </div>
        </div>
        <Pagination :size=list.length :pageLimit=8 style="margin:20px 0"></Pagination>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        name: "WorkApproval",
        components:{Pagination},
        data(){
            return{
                list: [],
                workInfo:{
                    pageObject:{
                        pageSize:8,
                        currentPage:1
                    },
                    model:{
                        status:1,
                    }
                }
            }
        },
        created() {
            this.getWorks(this.workInfo);
        },
        methods:{
            openInfo(l){
                window.open("/WorkShow/"+l.jobId+"/"+l.userId);
            },
            getWorks(data){
                this.$json("/training/find","POST",data).then(res =>{
                    this.list = res.data.data;
                });
            },
        },
        filters:{
            checkType(data){
                switch (data) {
                    case 0:
                        return "催办";
                    case 1:
                        return "审批";
                }
            },
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/css/myCourse.less';
    .list:nth-child(odd), .list-title {
        background-color: #edf5ff;
    }
</style>
